import { LabelProps } from "@jsonforms/core";
import { withJsonFormsLabelProps } from "@jsonforms/react";

function LabelRendererComponent({ text, visible }: LabelProps) {
  if (!visible) return null;

  return (
    <div className="mb-1 block text-xs leading-6 font-semibold">{text}</div>
  );
}

export const LabelRenderer = withJsonFormsLabelProps(LabelRendererComponent);
